<template>
    <b-form-group :label="$t('form.label.tags')" label-for="tags">
        <multiselect
            id="tags"
            :state="state"
            :selected="value"
            :options="tagsOptions"
            @changeValue="$emit('update:value', $event)"
            :disabled="disabled"
        >
            <template slot="c-option" slot-scope="{ options: { option } }">
                <span>{{ option.label }}</span>
            </template>
        </multiselect>
    </b-form-group>
</template>

<script>
import api from '@/services/api'
import { Multiselect, mapperToOptions } from '@/views/components/selects'

export default {
    name: 'Tags',
    components: {
        Multiselect,
    },
    props: ['value', 'state', 'disabled', 'label'],
    data() {
        return {
            tagsOptions: [],
        }
    },
    mounted() {
        api.get('/tags', {
            params: {
                sortedBy: 'asc',
                orderBy: 'title',
            },
        })
            .then(resp => {
                const {
                    data: { data },
                } = resp
                this.tagsOptions = mapperToOptions(data)
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$emit('ready', true)
            })
    },
}
</script>
